import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './App.jsx'
import './styles.css'

// Static-site generation + client hydration. Content pages are prerendered to
// real HTML at build time (for SEO), then hydrate into the full SPA.
export const createRoot = ViteReactSSG({ routes })
